// Components
import InputSearch from "components/atoms/InputSearch";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";

import "./styles.sass";
import { useRef } from "react";
import Gr8MiniIframe from "../../organisms/GR8MiniIFrame";

const { VITE_APP_PROJECT_NAME } = import.meta.env;

const GameFormSearch = () => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const GTM = useGTM();
  const inputRef = useRef();
  const handleChange = (value) => {
    inputRef.current = value;
  };
  return (
    <div className="GameFormSearch">
      <InputSearch
        name="search"
        placeholder={t("casino.search.hint")}
        gtm={GTM.gameSearchKeyword}
        value=""
        onChange={handleChange}
      />
      {!isDesktop && (
        <>
          {!inputRef.current && VITE_APP_PROJECT_NAME === "glory" && (
            <Gr8MiniIframe />
          )}
          <span className="GameFormSearch__title">
            {t("casino.search.title")}
          </span>
        </>
      )}
    </div>
  );
};

export default GameFormSearch;
